import React, { ReactElement, useContext } from 'react'

import Button from '../Common/Components/Button'

import { getHelpTopicByTab, ReportTabID } from './Constants'

import { openHelpPortalByTopic } from '../Common/Utils'

import { LanguageContext } from '../Common/Contexts'

import CLanguageHandler from '../../NonReact/Languages/LanguageHandler'
import { ConfigureReport as ConfigureReportLanguage } from '../../../i18n'
import ConfigureReportSettingsContext from '../Common/Contexts/ConfigureReportSettingsContext'
import { DocTopic } from '../Common/Constants/Documentation'
import { ModalContext, ModalContextType } from '../Common/Contexts/ModalContext'
// CSS imports. Commented out because of current build process.

/**
 * Component properties type.
 */
type Props = {
    servletPath: string
    activeTabID: ReportTabID
    isSubmitDisabled: boolean
    closeModal: () => void
    submitReportConfiguration: () => void
}

/**
 * Report configuration modal actions component.
 * @param servletPath The path of the servlet.
 * @param activeTabID Currently active tab ID used to show the correct doc topic.
 * @param isSubmitDisabled Whether the submit button is disabled.
 * @param closeModal Close modal handler.
 * @param submitReportConfiguration Submit form handler.
 */
const FooterActions: React.FC<Props> = ({
    servletPath,
    activeTabID,
    isSubmitDisabled,
    closeModal,
    submitReportConfiguration
}: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    const { isDateTimeOnly } = useContext(ConfigureReportSettingsContext)
    const { popoutMode }: ModalContextType = useContext(ModalContext)

    const handleHelpClick = (): void => {
        openHelpPortalByTopic(
            servletPath,
            isDateTimeOnly ? DocTopic.RPTGRPTPROPSDATETIMETAB : getHelpTopicByTab(activeTabID)
        )
    }

    return (
        <div className='tabs-footer'>
            <Button
                label={language.get(ConfigureReportLanguage.ConfigureReport_ButtonHelpLabel)}
                onClick={handleHelpClick}
            />
            <Button
                customClass='configure-report-submit-button'
                label={language.get(ConfigureReportLanguage.ConfigureReport_ButtonSubmitLabel)}
                isDisabled={isSubmitDisabled}
                onClick={submitReportConfiguration}
            />
            <Button
                label={language.get(ConfigureReportLanguage.ConfigureReport_ButtonCancelLabel)}
                onClick={(): void => {
                    if (popoutMode) {
                        window.close()
                    } else {
                        closeModal()
                    }
                }}
                isOutlined={true}
            />
        </div>
    )
}

export default FooterActions
